import { ProgressBarInfo } from '@apply/components';

/** The "Background — Company & 20%+ Owners have:" checklist. */
export const ownerAndCompanyBackgroundOptions = [
    { id: 'felony', label: 'Criminal or felony conviction' },
    { id: 'litigation', label: 'Litigation with financial institution in last 12 months' },
    { id: 'liens', label: 'Outstanding real estate liens' },
    { id: 'delinquentLoan', label: '30+ days delinquent on real estate loan' },
    { id: 'delinquentSupplier', label: '30+ days delinquent to primary building supplier' },
    { id: 'foreclosure', label: 'Foreclosure within past 10 years' },
    { id: 'bankruptcy', label: 'Bankruptcy within past 10 years' },
    { id: 'bfiPayment', label: 'BFI payment issue in past 12 months' },
] as const;
export type OwnerAndCompanyBackgroundId = (typeof ownerAndCompanyBackgroundOptions)[number]['id'];

export interface ApplicationKeyItemsForm {
    loanAmount: number | undefined;
    purchasePrice: number | undefined;
    /** SQL-style date string, as produced by DateTimeBox. */
    targetClosingDate: string | undefined;
    /** Yes / No; undefined until the user picks one. */
    allInformationSubmitted: boolean | undefined;
    /** Ids of the background items that apply (none selected is a valid answer). */
    ownerAndCompanyBackground: OwnerAndCompanyBackgroundId[];
}

export const emptyApplicationKeyItemsForm: ApplicationKeyItemsForm = {
    loanAmount: undefined,
    purchasePrice: undefined,
    targetClosingDate: undefined,
    allInformationSubmitted: undefined,
    ownerAndCompanyBackground: [],
};

const isPositiveAmount = (value: number | undefined) => value !== undefined && value !== null && value > 0;

/** Completion for the Application & Key Items step, computed from the form data so it's known whether or not the step is open. */
export const getApplicationKeyItemsProgress = (form: ApplicationKeyItemsForm): ProgressBarInfo => {
    const fieldsComplete = [
        isPositiveAmount(form.loanAmount),
        isPositiveAmount(form.purchasePrice),
        !!form.targetClosingDate,
        form.allInformationSubmitted !== undefined,
        // ownerAndCompanyBackground isn't counted: having none of those items is a complete answer
    ];
    return {
        numberComplete: fieldsComplete.filter(Boolean).length,
        total: fieldsComplete.length,
    };
};
